var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.5733 18.35C30.5733 18.2607 30.5882 18.1714 30.5882 18.0821C30.5882 13.2458 26.7341 9.33212 21.9796 9.33212C18.5495 9.33212 15.6031 11.3708 14.2192 14.3172C13.6165 14.0122 12.9394 13.8336 12.2251 13.8336C10.0302 13.8336 8.19982 15.4631 7.85011 17.591C5.21618 18.4988 3.33374 21.0211 3.33374 23.9899C3.33374 27.725 6.31737 30.7607 9.99297 30.7607H17.6195V24.8083H14.0332L20.0004 18.5806L25.9677 24.8009H22.3814V30.7532H30.5882C33.9513 30.7532 36.6671 27.9631 36.6671 24.5479C36.6671 21.1327 33.9364 18.3574 30.5733 18.35Z",
    fill: "#878A99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/UploadFile.121de4924e883468c6734cb239f37e9f.svg";
export { ForwardRef as ReactComponent };